import { render, staticRenderFns } from "./SecondaryInsurance.vue?vue&type=template&id=3472f9eb"
import script from "./SecondaryInsurance.vue?vue&type=script&lang=js"
export * from "./SecondaryInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports